// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallType {
    All = 0,
    Service = 1,
    Installation = 2,
    Maintenance = 3,
}

export let nameof = "ServiceCallType";
